var exports = {
  "Kk": "shared.module__icon___NlAyLV",
  "Bx": "shared.module__iconSmall___NlAyLV",
};

module.exports = exports;
